/**
 * i18n — i18next + react-i18next + détection navigateur + persistance localStorage.
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import fr from "./fr.json";

// Keep assistive technologies aligned with both persisted and temporary locales.
function syncDocumentLanguage() {
  document.documentElement.lang = i18n.resolvedLanguage === "en" ? "en" : "fr";
}
i18n.on("languageChanged", syncDocumentLanguage);
i18n.on("initialized", syncDocumentLanguage);

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "kollectivia-locale",
    },
  });

export default i18n;
